import { ButtonBase, Menu, MenuItem } from '@material-ui/core'
import HelpOutlineIcon from '@material-ui/icons/HelpOutline'
import WebIcon from '@material-ui/icons/Web'
import WhatsAppIcon from '@material-ui/icons/WhatsApp'
import clsx from 'clsx'
import { useState } from 'react'

import { useStyles } from './styles'

const HelpCenter = () => {
  const classes = useStyles()
  const [anchorEl, setAnchorEl] = useState(null)

  const handleOpen = (event: any) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <div>
      <ButtonBase
        className={clsx(classes.button, {
          [classes.hover]: anchorEl,
        })}
        onClick={handleOpen}
      >
        <HelpOutlineIcon className={classes.icon} />
        <span className={classes.span}>Ajuda</span>
      </ButtonBase>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        className={classes.menu}
        disableAutoFocusItem
        transformOrigin={{
          vertical: -56,
          horizontal: 76,
        }}
      >
        <MenuItem
          className={classes.menuItem}
          onClick={handleClose}
          component='a'
          href='https://sites.google.com/cromai.com/central-de-ajuda/central-de-ajuda'
          target='_blank'
        >
          <WebIcon className={classes.menuIcon} />
          Central de Ajuda
        </MenuItem>
        <MenuItem
          className={classes.menuItem}
          onClick={handleClose}
          component='a'
          href='https://api.whatsapp.com/send/?phone=5511915974322&text&type=phone_number&app_absent=0&text=Ol%C3%A1%2C%20vim%20pelo%20Cromai%20Atlas,%20preciso%20de%20ajuda!'
          target='_blank'
        >
          <WhatsAppIcon className={classes.menuIcon} />
          Suporte Remoto
        </MenuItem>
      </Menu>
    </div>
  )
}
export default HelpCenter
